export const cn = {
    NavBar: {
        HOME: '新任务',
        SEARCH_TASK: '搜索任务',
        AI_STUDIO: 'AI 工作站',
        CUSTOM_AGENT: '探索',
        WORK_PROJECT: '项目',
        VAULT: '知识库',
        MONITOR: '情报简报',
        COMMUNITY: '发现广场',
        AGENT_LIST: '智能体',
        CUSTOMIZE_LIST: '个性化',
        HISTORY: '最近任务',
        deleteTitle: '确认删除记录',
        deleteContent: '您确定要永久删除此记录吗？删除后将无法恢复此数据。',
        cancel: '取消',
        confirm: '删除',
        deleteSuccess: '您的记录已成功删除',
        open: '展开侧栏',
        close: '关闭侧栏',
        INCOGNITO: '已开启无痕模式',
        INCOGNITO_TIP: '无痕模式下，您的搜索记录将不会被保存',
        deleteAllTitle: '确认删除所有缓存及已有记录',
        deleteAllContent: '您确定要删除所有数据吗？删除后将无法恢复, 您分享的内容也将立即失效。',
        Upgrade: '立即升级',
    },
    HistoryType: {
        SEEK_SEARCH: '技术信息问答​',
        TECH_MIND: '技术方案探索',
        RD_TECH_MIND: '技术方案探索',
        TECH_RESEARCH: '技术预研报告',
        TECH_FMEA: '设计失效分析',
        PATENT_DISCLOSURE: '专利交底书助手',
        MATERIAL_MIND: '技术方案探索 材料',
        AI_TRANSLATION: '专利翻译',
        AI_SPECIFICATION: '专利说明书撰写',
        AI_PATENT_DISCLOSURE: '技术交底书撰写',
        AI_NOVELTY_SEARCH: '查新检索',
        AI_FTO_SEARCH: '防侵权检索',
        AI_NEW_FTO_SEARCH: '防侵权检索',
        AI_GENERATE: 'AI Agent',
        LS_DOCUMENT_QA: 'Biomed Document Analysis',
        LS_CHAT: 'Biomed Q&A Hub',
        LS_MARKUSH_PATENT_DRAFT: 'Markush Claim Drafting',
        TRIZ_MIND: 'TRIZ 寻找创新方案',
        TRIZ_PRO: 'TRIZ 寻找创新方案',
        RD_TRIZ_MIND: 'TRIZ 寻找创新方案',
        RD_DEEP_COST: 'DeepCost 研发降本',
    },
    SearchTaskDialog: {
        searchPlaceholder: '搜索历史记录...',
        newTasks: '新任务',
        noTasksFound: '暂无历史记录',
    },
    GuestToMaster: {
        subject: '免费注册',
        rights: 'Eureka 赋能您的创新全流程，让创新更专注、更高效。',
    },
}

export const en = {
    NavBar: {
        HOME: 'New Task',
        SEARCH_TASK: 'Search Tasks',
        AI_STUDIO: 'AI Studio',
        CUSTOM_AGENT: 'Explore',
        WORK_PROJECT: 'Project',
        VAULT: 'Vault',
        MONITOR: 'Pulse',
        COMMUNITY: 'Gallery',
        AGENT_LIST: 'Agent',
        CUSTOMIZE_LIST: 'Customize',
        HISTORY: 'Recents',
        deleteTitle: 'Confirm Record Deletion',
        deleteContent: 'Are you sure you want to permanently delete this record? This action cannot be undone.',
        cancel: 'Cancel',
        confirm: 'Delete',
        deleteSuccess: 'Your record has been deleted successfully',
        open: 'Expand Sidebar',
        close: 'Collapse Sidebar',
        INCOGNITO: 'Incognito Mode',
        INCOGNITO_TIP: 'In Incognito Mode, your search history will not be saved.',
        deleteAllTitle: 'Confirm Deletion of All Cache and Existing Records',
        deleteAllContent: 'Are you sure you want to delete all data? This action cannot be undone, and any content you have shared will immediately become inaccessible.',
        Upgrade: 'Upgrade',
    },
    HistoryType: {
        SEEK_SEARCH: 'Scope problem',
        TECH_MIND: 'Find solutions',
        RD_TECH_MIND: 'Find solutions',
        TECH_RESEARCH: 'Quick research',
        TECH_FMEA: 'DFMEA Assistant',
        PATENT_DISCLOSURE: 'Invention disclosure assistant',
        MATERIAL_MIND: 'Find solutions  Materials',
        AI_TRANSLATION: 'Patent Translation',
        AI_SPECIFICATION: 'Patent Specification',
        AI_PATENT_DISCLOSURE: 'Invention Disclosure',
        AI_NOVELTY_SEARCH: 'Novelty Search',
        AI_FTO_SEARCH: 'FTO Search',
        AI_NEW_FTO_SEARCH: 'FTO Search',
        AI_GENERATE: 'AI Agent',
        LS_DOCUMENT_QA: 'Biomed Document Analysis',
        LS_CHAT: 'Biomed Q&A Hub',
        LS_MARKUSH_PATENT_DRAFT: 'Markush Claim Drafting',
        TRIZ_MIND: 'Find Solutions with TRIZ',
        TRIZ_PRO: 'Find Solutions with TRIZ',
        RD_TRIZ_MIND: 'Find Solutions with TRIZ',
        RD_DEEP_COST: 'DeepCost R&D Cost Reduction',
    },
    SearchTaskDialog: {
        searchPlaceholder: 'Search history...',
        newTasks: 'New Task',
        noTasksFound: 'No history found',
    },
    GuestToMaster: {
        subject: 'Try it for free',
        rights: 'Automate and accelerate your workflows with Eureka\'s AI agents.',
    },
}

export const jp = {
    NavBar: {
        HOME: '新しいタスク',
        SEARCH_TASK: '検索タスク',
        AI_STUDIO: 'AI 工作站',
        CUSTOM_AGENT: 'Explore',
        WORK_PROJECT: 'プロジェクト',
        VAULT: 'ボールト',
        MONITOR: '動向モニター',
        COMMUNITY: '発見広場',
        AGENT_LIST: 'エージェント',
        CUSTOMIZE_LIST: 'カスタマイズ',
        HISTORY: '最近のタスク',
        deleteTitle: '記録削除の確認',
        deleteContent: 'この記録を完全に削除してもよろしいですか？削除後、このデータは復元できません。',
        cancel: 'キャンセル',
        confirm: '削除',
        deleteSuccess: '記録が削除されました',
        open: 'サイドバーを展開',
        close: 'サイドバーを閉じる',
        INCOGNITO: 'シークレット有効',
        INCOGNITO_TIP: 'シークレットモードでは、検索履歴は保存されません。',
        deleteAllTitle: 'すべてのキャッシュと既存の記録を削除しますか？',
        deleteAllContent: 'すべてのデータを削除してもよろしいですか？この操作は元に戻すことができません。共有したコンテンツもすぐにアクセスできなくなります。',
        Upgrade: 'アップグレード',
    },
    HistoryType: {
        SEEK_SEARCH: '技術情報問答',
        TECH_MIND: '技術ソリューション探索',
        RD_TECH_MIND: '技術ソリューション探索',
        TECH_RESEARCH: 'クイックリサーチ',
        TECH_FMEA: 'クイックリサーチ',
        PATENT_DISCLOSURE: '発明届出書アシスタント',
        MATERIAL_MIND: '技術方案の探索 材料',
        AI_TRANSLATION: 'Patent Translation',
        AI_SPECIFICATION: 'Patent Specification',
        AI_PATENT_DISCLOSURE: 'Invention Disclosure',
        AI_NOVELTY_SEARCH: 'Novelty Search',
        AI_FTO_SEARCH: 'FTO Search',
        AI_NEW_FTO_SEARCH: 'FTO Search',
        AI_GENERATE: 'AI Agent',
        LS_DOCUMENT_QA: 'Biomed Document Analysis',
        LS_CHAT: 'Biomed Q&A Hub',
        LS_MARKUSH_PATENT_DRAFT: 'Markush Claim Drafting',
        TRIZ_MIND: 'ソシューション探索 (TRIZ)リューションを探す',
        TRIZ_PRO: 'ソシューション探索 (TRIZ)リューションを探す',
        RD_TRIZ_MIND: 'ソシューション探索 (TRIZ)リューションを探す',
        RD_DEEP_COST: 'DeepCost 研究開発コスト削減',
    },
    SearchTaskDialog: {
        searchPlaceholder: '履歴を検索...',
        newTasks: '新しいタスク',
        noTasksFound: '履歴がありません',
    },
    GuestToMaster: {
        subject: '無料で試してみる',
        rights: 'Eureka の AI エージェントで業務を自動化・効率化し、イノベーションに集中しよう。',
    },
}

export const tw = {
    NavBar: {
        HOME: '新任務',
        SEARCH_TASK: '搜尋任務',
        AI_STUDIO: 'AI 工作站',
        CUSTOM_AGENT: 'Explore',
        WORK_PROJECT: '工作項目',
        VAULT: '知識庫',
        MONITOR: '情報簡報',
        COMMUNITY: '發現廣場',
        AGENT_LIST: '智能體',
        CUSTOMIZE_LIST: '個人化',
        HISTORY: '最近任務',
        deleteTitle: '確認刪除記錄',
        deleteContent: '您確定要永久刪除此記錄嗎？刪除後將無法恢復此數據。',
        cancel: '取消',
        confirm: '刪除',
        deleteSuccess: '您的記錄已成功刪除',
        open: '展開側欄',
        close: '關閉側欄',
        INCOGNITO: '已開啟無痕模式',
        INCOGNITO_TIP: '無痕模式下，您的搜索記錄將不會被保存',
        deleteAllTitle: '確認刪除所有緩存及已有記錄',
        deleteAllContent: '您確定要刪除所有數據嗎？刪除後將無法恢復, 您分享的內容也將立即失效。',
        Upgrade: '立即升級',
    },
    HistoryType: {
        SEEK_SEARCH: '技術資訊問答',
        TECH_MIND: '技術方案探索',
        RD_TECH_MIND: '技術方案探索',
        TECH_RESEARCH: '技術預研報告',
        TECH_FMEA: '設計失效分析',
        PATENT_DISCLOSURE: '專利交底書助手',
        MATERIAL_MIND: '技術方案探索 材料',
        AI_TRANSLATION: '專利翻譯',
        AI_SPECIFICATION: '專利說明書撰寫',
        AI_PATENT_DISCLOSURE: '技術交底書撰寫',
        AI_NOVELTY_SEARCH: '查新檢索',
        AI_FTO_SEARCH: '防侵權檢索',
        AI_NEW_FTO_SEARCH: '防侵權檢索',
        AI_GENERATE: 'AI Agent',
        LS_DOCUMENT_QA: 'Biomed Document Analysis',
        LS_CHAT: 'Biomed Q&A Hub',
        LS_MARKUSH_PATENT_DRAFT: 'Markush Claim Drafting',
        TRIZ_MIND: 'TRIZ 尋找創新方案',
        TRIZ_PRO: 'TRIZ 尋找創新方案',
        RD_TRIZ_MIND: 'TRIZ 尋找創新方案',
        RD_DEEP_COST: 'DeepCost 研發降本',
    },
    SearchTaskDialog: {
        searchPlaceholder: '搜尋歷史記錄...',
        newTasks: '新任務',
        noTasksFound: '暫無歷史記錄',
    },
    GuestToMaster: {
        subject: '免費註冊',
        rights: 'Eureka 賦能您的創新全流程，讓創新更專注、更高效。',
    },
}
